import { autoUploadUnsubs, autoUploadUnsubsStep2 } from 'reactApp/appHelpers/featuresHelpers/features/autoUploadPromo';
import { SPACE_LIST } from 'reactApp/constants/spaceList';
import type {
    CheckOffer,
    OutflowOfferMobileProps,
    OutflowOfferWebProps,
} from 'reactApp/modules/subscriptionRenewal/outflowOffers/offers.types';
import {
    closeCancelAutoRenewAutouploadModal,
    renderCancelAutoRenewAutouploadModal,
} from 'reactApp/ui/CancelAutoRenewAutouploadModal/CancelAutoRenewAutouploadModal.helpers';

export function checkUnlimitedAutoUploadOffer({ product }: CheckOffer) {
    return autoUploadUnsubs && autoUploadUnsubsStep2 && product.space.original >= SPACE_LIST.gb_256;
}

export function* unlimitedAutoUploadOffer({ subscription, continueOutflow, cancelOutflow }: OutflowOfferWebProps) {
    yield renderCancelAutoRenewAutouploadModal({
        subscription,
        onCancel() {
            closeCancelAutoRenewAutouploadModal();
            continueOutflow();
        },
        onClose() {
            closeCancelAutoRenewAutouploadModal();
            cancelOutflow();
        },
        onSuccess() {
            closeCancelAutoRenewAutouploadModal();
            cancelOutflow();
        },
    });
}

export function* unlimitedAutoUploadOfferMobile(props: OutflowOfferMobileProps) {
    yield unlimitedAutoUploadOffer(props);
}
